import axios from 'axios';

export const send = (params) => {
  return axios.post('Amo/Send', params);
};
